import type { NavbarWidgetAttribute, NavbarWidgetProps } from './types';

export const DEFAULT_NAVBAR_WIDGET_PROPS: NavbarWidgetProps = {
  country: 'CL',
  authState: 'guest',
};

export const OBSERVED_NAVBAR_WIDGET_ATTRIBUTES: NavbarWidgetAttribute[] = [
  'platform-country',
  'auth-state',
  'user-name',
  'user-email',
  'user-avatar-url',
  'logo-url',
  'home-url',
  'login-url',
  'register-url',
  'account-url',
  'classroom-url',
  'classroom-badge',
  'lab-url',
  'lab-badge',
  'profile-url',
  'logout-url',
  'cart-item-count',
  'cart-loading',
  'search-base-url',
  'search-placeholder',
  'search-auto-suggest',
  'search-suggest-url',
  'search-debounce-ms',
  'search-min-length',
  'search-max-results',
  'sticky',
  'hide-user-actions',
  'hide-login',
  'nav-items',
  'data-preview-auth',
];

function readNumberAttribute(element: HTMLElement, name: string): number | undefined {
  const value = element.getAttribute(name);
  if (value === null) return undefined;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function readBooleanAttribute(element: HTMLElement, name: string): boolean | undefined {
  const value = element.getAttribute(name);
  if (value === null) return undefined;

  return value !== 'false';
}

export function readNavbarWidgetProps(element: HTMLElement): NavbarWidgetProps {
  const previewAuth = element.getAttribute('data-preview-auth') as 'guest' | 'authenticated' | null;

  return {
    country:
      (element.getAttribute('platform-country') as 'CL' | 'MX' | 'CO' | null) ??
      DEFAULT_NAVBAR_WIDGET_PROPS.country,
    authState:
      previewAuth ??
      (element.getAttribute('auth-state') as 'guest' | 'authenticated' | null) ??
      DEFAULT_NAVBAR_WIDGET_PROPS.authState,
    userName: element.getAttribute('user-name') ?? undefined,
    userEmail: element.getAttribute('user-email') ?? undefined,
    userAvatarUrl: element.getAttribute('user-avatar-url') ?? undefined,
    logoUrl: element.getAttribute('logo-url') ?? undefined,
    homeUrl: element.getAttribute('home-url') ?? undefined,
    loginUrl: element.getAttribute('login-url') ?? undefined,
    registerUrl: element.getAttribute('register-url') ?? undefined,
    accountUrl: element.getAttribute('account-url') ?? undefined,
    classroomUrl: element.getAttribute('classroom-url') ?? undefined,
    classroomBadge: element.getAttribute('classroom-badge') ?? undefined,
    labUrl: element.getAttribute('lab-url') ?? undefined,
    labBadge: element.getAttribute('lab-badge') ?? undefined,
    profileUrl: element.getAttribute('profile-url') ?? undefined,
    logoutUrl: element.getAttribute('logout-url') ?? undefined,
    cartItemCount: readNumberAttribute(element, 'cart-item-count'),
    cartLoading: readBooleanAttribute(element, 'cart-loading'),
    searchBaseUrl: element.getAttribute('search-base-url') ?? undefined,
    searchPlaceholder: element.getAttribute('search-placeholder') ?? undefined,
    searchAutoSuggest: readBooleanAttribute(element, 'search-auto-suggest'),
    searchSuggestUrl: element.getAttribute('search-suggest-url') ?? undefined,
    searchDebounceMs: readNumberAttribute(element, 'search-debounce-ms'),
    searchMinLength: readNumberAttribute(element, 'search-min-length'),
    searchMaxResults: readNumberAttribute(element, 'search-max-results'),
    sticky: readBooleanAttribute(element, 'sticky'),
    hideUserActions: readBooleanAttribute(element, 'hide-user-actions'),
    hideLogin: readBooleanAttribute(element, 'hide-login'),
    navItemsJson: element.getAttribute('nav-items') ?? undefined,
  };
}
